import './SearchResults.scss'

import React from 'react'
import pluralize from 'pluralize'

import ListResult from './ListResult/ListResult'
import ItemResult from './ItemResult/ItemResult'

const SearchResults = ({ searchResults }) => {
  const { listResults, itemResults } = searchResults

  const renderListResults = () => (
    <section className="search-results__results-section">
      <div className="search-results__results-count">{pluralize('List Result', listResults.totalElements, true)}</div>

      {listResults.content.map((list) => (
        <div className="search-results__result">
          <ListResult list={list} key={list.getID()} />
        </div>
      ))}
    </section>
  )

  const renderItemResults = () => (
    <section className="search-results__results-section">
      <div className="search-results__results-count">{pluralize('Item Result', itemResults.length, true)}</div>

      {itemResults.map((item) => (
        <div className="search-results__result">
          <ItemResult item={item} key={item.availabilityId} />
        </div>
      ))}
    </section>
  )

  return (
    <div className="search-results">
      <div className="search-results__container">
        {listResults.totalElements > 0 && renderListResults()}
        {itemResults.length > 0 && renderItemResults()}
      </div>
    </div>
  )
}

export default SearchResults
